import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from '@tanstack/react-query';
import { knowledgeBaseApi } from 'api/knowledgeBase';
import { DialogConfirm, DialogConfirmExtendProps } from 'components/_new/Dialog';
import { useKnowledgeBase } from 'components/knowledgeBase/knowledgeBaseContext';
import { useGlobal } from 'contexts/globalContext';
import { useScope } from 'contexts/scopeContext';

type RemoveDirectoryDialogProps = DialogConfirmExtendProps & { directoryId: number | null };

export const RemoveDirectoryDialog = ({ directoryId, ...dialogProps }: RemoveDirectoryDialogProps) => {
	const { t } = useTranslation();

	const { toastRef } = useGlobal();
	const { currentProgram: data } = useScope();
	const { directoriesQuery } = useKnowledgeBase();

	const {
		data: knowledgeBaseDirectory,
		// isSuccess: knowledgeBaseDirectorySuccess,
		// isLoading: knowledgeBaseDirectoryLoading,
	} = useQuery(
		['KNOWLEDGE_BASE_PP_DIRECTORY', { directoryId, programId: Number(data?.id) }],
		() => knowledgeBaseApi.program.getProgramDirectory(Number(data?.id), Number(directoryId)),
		{
			enabled: Boolean(dialogProps.visible) && Boolean(directoryId),
		}
	);

	const { mutateAsync: removeDirectoryMutate } = useMutation(
		() => knowledgeBaseApi.program.removeProgramDirectory(Number(data?.id), Number(directoryId)),
		{
			onSuccess: () => {
				toastRef?.current?.show({
					severity: 'success',
					life: 3000,
					summary: t('misc.success'),
					detail: t('knowledgeBase.programPanel.directoryRemoved'),
				});
				directoriesQuery.refetch();
				dialogProps?.onHide?.();
			},
		}
	);

	const directoryName = knowledgeBaseDirectory?.translations?.[0]?.text || '';

	return (
		<DialogConfirm
			message={t('knowledgeBase.programPanel.confirmRemoveDirectory', { directoryName })}
			{...dialogProps}
			onConfirm={() => {
				return removeDirectoryMutate();
			}}
			visible={dialogProps.visible && Boolean(directoryId)}
		/>
	);
};
